import * as React from 'react';
import CompareGroupSelector from "./CompareGroupSelector";
import CTSAReportHeader from "./CTSAReportHeader";
import TeamComposition from "./TeamComposition";
import { getTeam, getTeamGender, transformTotals } from './CTSAReportHelper';

interface Props {
    comparisonGroup?: string[];
    availableGroup?: string[];
    changeComparisonGroup?();
    displayId?: string;
    CTSASchoolList?: {}[];
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number };
    team?: {}[];
    teamGender?: {}[];
}


class TeamScience extends React.Component<Props, {}> {
    render() {
        const { awardTotal, team, teamGender, comparisonGroup, changeComparisonGroup, availableGroup, displayId, CTSASchoolList
        } = this.props;
        if (awardTotal && team && teamGender && comparisonGroup) {

            return (
                <div className="tabcontents container-fluid" style={{ border: 'none' }}>
                    <CTSAReportHeader compareGroup={comparisonGroup} displayId={displayId} CTSASchoolList={CTSASchoolList} awardTotal={transformTotals(awardTotal)} />
                    <CompareGroupSelector
                        onChange={changeComparisonGroup}
                        selectedGroup={comparisonGroup}
                        awardTotal={transformTotals(awardTotal)}
                        availableGroup={availableGroup}
                    />

                               
                        <TeamComposition teamComposition={getTeam(team, comparisonGroup)} teamGenderComposition={getTeamGender(teamGender, comparisonGroup)} />                  
                    <img src={require('./CTSA_logo.jpg')} height='50px' style={{ marginTop: '20px' }} />

                </div>
            );



        } else {
            return <i className="fa fa-spinner"></i>;
        }


    }
}

export default TeamScience;



